<template>
    <admin-layout 
    title="View Voucher"
    show-back
    backUrl="/vouchers">

        <div class="divide-y">
            <div
                v-if="$hasPermission('cancel-vouchers') && (voucherData?.status == 1 || voucherData?.status == 2)" 
                class="flex justify-end px-6 py-3"
            >
                <ButtonComponent
                    type="button"
                    color="text-white bg-red-600 border-red-600"
                    class="h-10"
                    @click="showConfirmation = true"
                >
                    <XMarkIcon class="w-5 h-5 mr-2" />
                    Cancel
                </ButtonComponent>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Voucher No.</div>
                <div class="w-9/12">{{voucherData?.id}}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Date Created</div>
                <div class="w-9/12">{{ formatDateTime(voucherData?.created_at) }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Voucher Name</div>
                <div class="w-9/12">{{ voucherData?.name }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Voucher Code</div>
                <div class="w-9/12">{{ voucherData?.code }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Status</div>
                <div class="w-9/12">
                    <StatusPill
                    :color="getStatus(voucherData?.status).color"
                    :text="getStatus(voucherData?.status).text"/>
                </div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Participating Packages</div>
                <div class="w-9/12">
                    <template v-if="voucherData?.packages.length > 0">
                        {{ getSelectedNames(voucherData?.packages, packages) }}
                    </template>
                    <template v-else>
                        All
                    </template>
                </div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Participating Riders</div>
                <div class="w-9/12">
                    <template v-if="voucherData?.riders.length > 0">
                        {{ getSelectedNames(voucherData?.riders, riders) }}
                    </template>
                    <template v-else>
                        All
                    </template>
                </div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Participating Patients</div>
                <div class="w-9/12">
                    <template v-if="voucherData?.patients.length > 0">
                        {{ getSelectedNames(voucherData?.patients, patients) }}
                    </template>
                    <template v-else>
                        All
                    </template>
                </div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Maximum Usage Count</div>



                <div class="w-9/12">
                    <template v-if="voucherData?.max_usage_type == MaxUsageType.NONE">
                        None
                    </template>
                    <template v-else>
                        {{ voucherData?.max_usage_count }} ({{ voucherData?.max_usage_count - voucherData?.usage_count }} usages left)
                    </template>
                </div>
            </div>

            <!-- TODO: For clarification -->
            <!-- <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Maximum Order Count</div>
                <div class="w-9/12">
                    {{ voucherData?.max_usage_type }}
                </div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Minimum Order Value</div>
                <div class="w-9/12">
                    <template v-if="voucherData?.max_usage_count">
                        {{ formatter.format(voucherData?.max_usage_count) }}
                    </template>
                    <template v-else>
                        Unlimited
                    </template>
                </div>
            </div> -->
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Requirement Type</div>
                <div class="w-9/12">{{ getRequirementType(voucherData?.requirement_type) }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Requirement Value</div>
                <div class="w-9/12">{{ formatter.format(voucherData?.requirement_value) }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Discount Type</div>
                <div class="w-9/12">{{ getDiscountType(voucherData?.discount_type) }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Discount Value</div>
                <div class="w-9/12">
                    <template v-if="voucherData?.discount_type == DiscountType.FIXED">
                        {{ formatter.format(voucherData?.discount_value) }}
                    </template>
                    <template v-else>
                        {{ voucherData?.discount_value }}%
                    </template>
                </div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Start Date</div>
                <div class="w-9/12">{{ formatDateTime(voucherData?.start_at, 'Asia/Manila', 'MMM dd, yyy HH:mm:ss') }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">End Date</div>
                <div class="w-9/12">{{ formatDateTime(voucherData?.end_at, 'Asia/Manila', 'MMM dd, yyy HH:mm:ss') }}</div>
            </div>
            <div class="flex items-center p-6 space-x-6">
                <div class="w-3/12">Description</div>
                <div class="w-9/12">{{ voucherData?.description }}</div>
            </div>
        </div>

        <ConfirmationModal
            :show="showConfirmation"
            @cancel="showConfirmation = false"
            @confirm="showConfirmation = false; handleCancel() "
            cancel-text="Cancel"
            action-text="Confirm"
            title="Cancel Voucher ?"
            content="Are you sure you wish to cancel this voucher?"
        />

        <SuccessModal
            :show="showSuccess"
            @cancel="showSuccess = false"
            @confirm="showSuccess = false"
            action-text="Close"
            title="Cancellation Successful"
            content="Your voucher cancellation request has been completed"
        />
 
       
        <PageLoader v-if="loader" />

    </admin-layout>
</template>

<script setup lang="ts">
import AdminLayout from '@/layouts/AdminLayout.vue';
import ButtonComponent from "@/components/ButtonComponent.vue";
import { XMarkIcon } from "@heroicons/vue/24/solid";
import PageLoader from "@/components/PageLoader.vue";
import StatusPill from '@/components/StatusPill.vue';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import voucher from "@/classes/Voucher";
import { formatter } from '@/helpers/NumberHelper'
import { format, parseISO } from 'date-fns';
import { RequirementType } from '@/enums/RequirementType';
import { DiscountType } from '@/enums/DiscountType';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import DropdownData from '@/classes/DropdownData';
import { MaxUsageType } from '@/enums/MaxUsageType';
import { formatDateTime, formatDate } from '@/helpers/TimeFormatter'


const route = useRoute();
const loader = ref(true);
const voucherData = ref(null);
const showConfirmation  = ref(false);
const showSuccess      = ref(false);
const packages = ref(false);
const riders = ref(false);
const patients = ref(false);

const fetchVoucherData = async () => {
    try {
        const voucherId = route.params.id as string;
        const response = await voucher.editVoucher(voucherId);
        voucherData.value = response.data.voucher;
        packages.value = response.data.packages;
        patients.value = response.data.patients;
        formatRiderOptions(response.data.riders);
    } catch (error) {
        console.error("Error fetching voucher data:", error);
    } finally {
        loader.value = false;
    }
};


const getSelectedNames = (ids: string[], data:any):string => {

    if(data){        
        const selectedValues = data.filter((item:any) => ids.includes(item.id));
        return  selectedValues.map((item:any) => item.name).join(", ");
    }

    return "--";
}

const formatRiderOptions = (data:any): void => {
    let options:any = [];

    data.forEach((rider:any) => {
        options = options.concat(
            rider.items.map((item) => {
                return {
                    id: item.item_id,
                    name: item.item_name
                }
            })
        )
    });

    riders.value = options;
}

const getRequirementType = (type: number) => {
    switch (type) {
        case RequirementType.AMOUNT:
        return 'Amount';
        case RequirementType.QUANTITY:
        return 'Quantity';
        default:
        return 'Unknown';
    }
}

const getDiscountType = (type: number) => {
    switch (type) {
        case DiscountType.FIXED:
        return 'Fixed';
        case DiscountType.PERCENTAGE:
        return 'Percentage';
        default:
        return 'Unknown';
    }
}


const getStatus = (status: number) => {
    let color = 'yellow';
    let text = 'Unknown';

    switch (status) {
        case 1:
            color = 'violet';
            text = 'Scheduled';
            break;
        case 2:
            color = 'yellow';
            text = 'Ongoing';
            break;
        case 3:
            color = 'red';
            text = 'Expired';
            break;
        case 4:
            color = 'red';
            text = 'Cancelled';
            break;
    }

    return { color, text };
}

const handleCancel = async () => {
    try {
        if (voucherData.value) {
            await voucher.cancelVoucher(voucherData.value.id);

            voucherData.value.status = 4; 
            
            showSuccess.value = true;
           
        }
    } catch (error) {
        console.error("Error cancelling voucher:", error);
        // Optionally, you can show an error message to the user
    }
};

onMounted(async () => {
    await fetchVoucherData();
});


</script>